<div class="ttmodal">
  <div class="ttmodal__header">
      <span class="ttmodal__title">Project Contacts</span>
      <i class="material-icons ttmodal__close-button" (click)="onCloseClick()">close</i>
  </div>
  <div class="ttmodal__body">
    <div style="margin-left: 39%;" *ngIf="loading">
      <mat-spinner> </mat-spinner>
  </div>

    <div *ngIf="!loading">
      <div class="input-container">
        <span class="label" >Name</span>
        <mat-select id="select-user" placeholder="Select Name" [(ngModel)]="selectedName" class="get-Input" style="max-width: 300px;"
        ngDefaultControl required (selectionChange)="onSelectName()">
        <mat-option [value]="user.Id" *ngFor="let user of usernameList">
          {{user.Name}}
        </mat-option>
      </mat-select>

      </div>

      <div class="input-container">
        <span class="label">Email Address</span>
        <input type="text"    [(ngModel)]="email" disabled  class="get-Input-300"/>
      </div>

      <div class="input-container">
        <span class="label">Role</span>
        <input type="text"    [(ngModel)]="role"  disabled class="get-Input-300"/>
      </div>

      <div class="input-container">
        <span class="label">Contact Event</span>
        <mat-select id="select-user" placeholder="Select Event" [(ngModel)]="selectedEvent" class="get-Input" style="max-width: 300px;"
        ngDefaultControl required (selectionChange)="onSelectEvent()" >
        <mat-option [value]="event.Id" *ngFor="let event of contacteventsList">
          {{event.Name}}
        </mat-option>
      </mat-select>
      </div>
      <div class="input-container">
        <span class="label">Frequency</span>
        <select id="requency" [(ngModel)]="selectedFrequency"  (change)="ChangeFrequency()" class="get-Input-300">
          <option value="1">Immediate</option>
          <option value="2">Daily</option>
          <option value="3">Weekly</option>
          <option value="4">Never</option>
        </select>
      </div>
    </div> 
     
  </div>
  <div class="ttmodal__footer" *ngIf="!loading">
      <a class="button margin-right-8" (click)="onCloseClick()"><span class="button__text">Cancel</span></a>
      <a class="button button--primary" [class.loading]="savingChanges" (click)="AddUpdateProjectContact()"><span
              class="button__text">Update</span></a>
            
  </div>
  <div class="ttmodal__body" *ngIf="!loading">
    <ng-container>
      <table class="table table--striped table--full-width"  style="font-size: small;">

        <thead>
            <tr>
                <th >Name</th>
                <th >Email</th>
                <th >Role</th>
                <th >Contact Event</th>
                <th >Frequency</th>
                <th></th>
            </tr>
        </thead>
        <tbody>
          <ng-container *ngFor="let item of ExistingContactInfo">
            <tr  >
                  <td class="CelltextWrap columncell" (click)="LoadData(item)">{{item.Name}}</td>
                  <td class="CelltextWrap columncell" (click)="LoadData(item)">{{item.Email}}</td>

                  <td class="CelltextWrap columncell" (click)="LoadData(item)">{{item.Role}}</td>
                  <td class="CelltextWrap columncell" (click)="LoadData(item)">SOW Approvals and Response</td>
                  <td class="CelltextWrap columncell" (click)="LoadData(item)">{{item.FrequencyName}}</td>
                  <td class="CelltextWrap columncell" >
                    <a  (click)="DeleteContact(item)"> <i class="material-icons square-button__icon" style="color: red;">delete_forever</i>
                     
                    </a>
                  </td>





            </tr>
            </ng-container>
        </tbody>
      </table>
    </ng-container>
    </div>

</div>